// src/contexts/nobishiro-dashboard/useUserProfile.js
import { useState, useEffect } from 'react';
import { getUserProfile } from '../../services/userService';
import { app } from '../../firebase';
import { getFirestore, doc, updateDoc } from 'firebase/firestore';

const db = getFirestore(app);

export const useUserProfile = (userId) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (userId === 'demo-user-12345') {
      setProfile({
        id: 'demo-user-12345',
        email: 'demo@example.com',
        username: 'デモユーザー',
        displayName: 'デモユーザー',
        subscription: { planId: 'pro', status: 'active', planName: 'Proプラン' },
        role: 'user',
        trizLawsMastery: {},
        growthPatternProfile: null,
        teamMemberships: [],
        weeklyGoalHours: 7,
        createdAt: new Date().toISOString(),
        lastLogin: new Date().toISOString(),
        settings: { notifications: true, language: 'ja', theme: 'light' }
      });
      setLoading(false);
      setError(null);
      return;
    }

    if (!userId) {
      setLoading(false);
      return;
    }

    const fetchProfile = async () => {
      try {
        setLoading(true);
        const userProfile = await getUserProfile(userId);
        setProfile(userProfile);
        setError(null);
      } catch (err) {
        console.error('Profile fetch error:', err);
        setError(err);
        setProfile(null);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [userId]);

  // Firestoreのusers/{userId}ドキュメントを更新してローカルstateにも反映
  const updateProfile = async (data) => {
    if (!userId || userId === 'demo-user-12345') {
      setProfile(prev => ({ ...prev, ...data }));
      return;
    }
    try {
      const ref = doc(db, 'users', userId);
      await updateDoc(ref, data);
      setProfile(prev => ({ ...prev, ...data }));
    } catch (err) {
      console.error('Profile update error:', err);
      throw err;
    }
  };

  return { profile, loading, error, updateProfile };
};
